























import Vue from "vue";
import { Prop, Component, Watch } from "vue-property-decorator";
import { Site } from "@/shared/Site";
import { MyOptions } from "@/charts/graphData";
import { mixins } from "vue-class-component";
import chartsMixin from "./chartsMixin";
import jsonURL from "@/shared/urls";
import moment from "moment/moment";
import NumberTmpl from "@/ui-component/number.vue";

@Component({
  components: {
    NumberTmpl,
  },
})
export default class CaData extends mixins(chartsMixin) {
  // position:absolute; top:50%; transform: translateY(-50%)
  public dataGetted = false;
  public caValue = { ht: 0, ttc: 0, lastP: 0 };
  public config: any;
  public titre = "";
  @Prop() public myOptions!: MyOptions;
  @Prop() public periode!: string;

  @Watch("myOptions", { immediate: true, deep: true })
  public onPeriodeChanged(value: any, oldValue: any) {
    this.init();
  }

  public mounted() {
    this.init();
  }

  public init() {
    this.config = {
      site: this.myOptions.site[0],
      periode: this.periode,
      date: moment(this.myOptions.date).format("YYYY-MM-DD"),
    };
    this.updateWs();
    this.orderTitre(this.config);
    this.getData();
  }

  private updateWs() {
    switch (this.periode) {
      case "J":
        this.config.WSttc = jsonURL.updateCASurJour;
        this.config.WSht = jsonURL.updateCAHTSurJour;
        break;
      case "MOIS":
        this.config.WSttc = jsonURL.updateCASurMoisPerso;
        this.config.WSht = jsonURL.updateCAHTSurMoisPerso;
        break;
      case "ANNEE":
        this.config.WSttc = jsonURL.updateCASurAnneePerso;
        this.config.WSht = jsonURL.updateCAHTSurAnneePerso;
        break;
    }
  }
  /**
   *
   */
  private getData() {
    this.$store
      .dispatch("home/getHomeData", {
        config: this.config,
        WS: this.config.WSttc,
      })
      .then((datattc: any) => {
        this.caValue.ttc = datattc;
        // this.
        this.$store
          .dispatch("home/getHomeData", {
            config: this.config,
            WS: this.config.WSht,
          })
          .then((dataht: any) => {
            // console.log(dataht);
            this.caValue.ht = dataht;
          });
      });
    this.$emit("loaded");
  }

  get sites(): Site[] {
    return this.$store.getters["login/sites"];
  }
}
